import React from 'react'

export default function PaneWrapper({ children }) {
  return (
    <div
      id="dashboard-pane-middle"
      className="app-pane pane column-md"
    >
      <div className="vertical">
        {children}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/guided-tour/components/PaneWrapper.js